export default __webpack_public_path__ + "f4e908aad01d8ac5bf14a023c549d6c4.svg";